import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { OccSeatingScreenPosition } from '../../../context/occ/types/config/seating/screen-position';
import { getAreaRectangle } from '../positioning/area';
import { SeatPickerContextInstance, SeatPickerSelectedSeatsContextInstance } from '../types/context';
import { SeatPickerRow } from './row';
const b = bemClassBuilder('v-seat-picker-area');
export const SeatPickerArea = observer(props => {
    const i18n = useI18n();
    const { area, areaCategory, seatAvailabilityMap, friendSeatIds, scaleFactor, mapRectangle } = props;
    const { data, config } = useContext(SeatPickerContextInstance);
    const selectedSeats = useContext(SeatPickerSelectedSeatsContextInstance);
    const rectangle = getAreaRectangle(area.boundary, mapRectangle, scaleFactor, config);
    const isLayoutInverted = config.screen.position === OccSeatingScreenPosition.Top;
    const rows = isLayoutInverted ? area.rows.slice().reverse() : area.rows; // Reversed so that the tab order of seats goes top-left to bottom-right
    const isSelectable = isAreaSelectable(areaCategory, data, config);
    return (_jsxs("g", { className: b.block({ category: areaCategory.id }), transform: `translate(${rectangle.x}, ${rectangle.y})`, children: [config.areaLabels.show && (_jsx("text", { className: b.element('label'), x: rectangle.width / 2, y: -config.areaLabels.margin, alignmentBaseline: "baseline", textAnchor: "middle", children: i18n.translatable(area.name) })), rows.map(row => {
                // Only render rows that have seats
                if (row.seats.length === 0) {
                    return null;
                }
                const selectedSeatIds = new Set(selectedSeats.filter(seat => seat.position.rowNumber === row.number).map(seat => seat.id));
                return (_jsx(SeatPickerRow, { row: row, area: area, seatAvailabilityMap: seatAvailabilityMap, selectedSeatIds: selectedSeatIds, friendSeatIds: friendSeatIds, scaleFactor: scaleFactor, isSelectable: isSelectable }, row.number));
            })] }));
});
SeatPickerArea.displayName = 'SeatPickerArea';
const isAreaSelectable = (areaCategory, data, config) => {
    var _a, _b;
    const showtimeAreaCategory = (_a = data.showtimeAreaCategories) === null || _a === void 0 ? void 0 : _a.find(s => s.areaCategoryId === areaCategory.id);
    const isAllocatedSeating = (_b = showtimeAreaCategory === null || showtimeAreaCategory === void 0 ? void 0 : showtimeAreaCategory.isAllocatedSeating) !== null && _b !== void 0 ? _b : areaCategory.isAllocatedSeating;
    const { allowSeatsInUnallocatedAreasToBeSelected } = config.seats;
    if (!allowSeatsInUnallocatedAreasToBeSelected && !isAllocatedSeating) {
        return false;
    }
    const { limitsPerAreaCategory } = data.seatSelectionLimits;
    const areaCategoryLimit = limitsPerAreaCategory && limitsPerAreaCategory[areaCategory.id];
    return areaCategoryLimit ? areaCategoryLimit.max > 0 : true;
};
//# sourceMappingURL=area.js.map